import { Component, OnInit, Input, ViewChild, OnChanges } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatTabChangeEvent } from '@angular/material';
import { ViewRequest } from '../shared/view-request.model';
import { ReportsService } from '../shared/reports.service';
import { RequestRecognition } from '../shared/request-recognition.model';

@Component({
  selector: 'app-view-requests-recognition',
  templateUrl: './view-requests-recognition.component.html',
  styleUrls: ['./view-requests-recognition.component.scss']
})
export class ViewRequestsRecognitionComponent implements OnInit, OnChanges {

  displayedColumns: string[] = ['fechaSolicitud', 'cedula', 'nombre', 'materiaPorRecon', 'institucion'];

  messageError: String = '';
  claseMessage: String = 'messaje-error';
  dataSource: MatTableDataSource<RequestRecognition>;

  @Input() requests: RequestRecognition[];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor() {
    this.setTable();
  }

  ngOnInit() {
    this.setTable();
  }

  private setTable() {
    this.dataSource = new MatTableDataSource(this.requests);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

  }

  ngOnChanges() {
    this.setTable();
  }

}
